export default (date: Date | string): string => {
  if (date instanceof Date) {
    return date.toISOString()
  }
  return date
}
